import { useMemo } from "react";

import { FixedSimpleDropdown } from "src/base-components/FixedSimpleDropdown";
import { PropertyDefinitionOutputTypeEnum } from "src/clients/features-control";
import {
  FILTERABLE_TYPES,
  JUNCTION_OPTIONS,
} from "src/eventsCatalogue/filters/constants";
import { getEventProperties } from "src/eventsCatalogue/filters/utils";
import { useEventSchemas } from "src/eventsCatalogue/queries";
import { findEventSchema } from "src/eventsCatalogue/utils";

type EventFieldsDropdownProps = {
  dataLoc: string;
  eventType: string;
  selectedKey: string;
  type: "field" | "junction";
  disabled?: boolean;
  onSelect: (key: string) => void;
};

export const EventFieldsDropdown: React.FC<EventFieldsDropdownProps> = ({
  dataLoc,
  eventType,
  selectedKey,
  type,
  disabled,
  onSelect,
}) => {
  const { data: eventSchemas } = useEventSchemas();
  const currentEvent = findEventSchema(eventType, eventSchemas);

  const eventProperties = useMemo(
    () => getEventProperties(currentEvent),
    [currentEvent],
  );

  const fieldOptions = useMemo(() => {
    return eventProperties
      .filter((property) => {
        const datatype = property.datatype as PropertyDefinitionOutputTypeEnum;
        const isFilterableType = FILTERABLE_TYPES.includes(datatype);

        // Exclude timestamp fields since we already have a date range picker
        const isTimestampField =
          datatype === PropertyDefinitionOutputTypeEnum.DATE ||
          datatype === PropertyDefinitionOutputTypeEnum.DATETIME ||
          property.name.toLowerCase().includes("timestamp");

        return isFilterableType && !isTimestampField;
      })
      .map((property) => ({
        key: property.name,
        value: property.displayName,
      }));
  }, [eventProperties]);

  const elements = type === "field" ? fieldOptions : JUNCTION_OPTIONS;
  const placeholder = type === "field" ? "Select field" : "and";

  return (
    <FixedSimpleDropdown
      dataLoc={dataLoc}
      disabled={disabled}
      elements={elements}
      placeholder={placeholder}
      selectedKey={selectedKey}
      onSelect={onSelect}
    />
  );
};
